export const generateFullHTMLTableString = (
  tableHeader: string[],
  tableBody: Record<string, string | number | null | undefined>[],
) => {
  const tableHeaders = tableHeader
    .map(
      (header: string) =>
        `<th style="padding: 12px 16px; border-right: 1px solid rgba(255,255,255,0.35); text-align: left; font-size: 14px; font-weight: 800; letter-spacing: 0.02em; color: #ffffff; background-color: #177ba6;">${header}</th>`,
    )
    .join('');

  const tableRows =
    tableBody.length > 0
      ? tableBody
          .map(
            (row: Record<string, string | number | null | undefined>) => `
                <tr>
                  ${tableHeader
                    .map(
                      (header: string) =>
                        `<td style="padding: 8px 16px; border: 1px solid #ccc;">${
                          row[header] ?? ''
                        }</td>`,
                    )
                    .join('')}
                </tr>
              `,
          )
          .join('')
      : `<tr><td colspan="${tableHeader.length}" style="text-align:center; padding: 12px;">No data available</td></tr>`;

  return `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <style>
          table {
            border-collapse: collapse;
            width: 100%;
            font-family: Arial, sans-serif;
          }
          th, td {
            border: 1px solid #ccc;
          }
          thead {
            background-color: #177ba6;
            color: white;
          }
          thead th:last-child {
            border-right: 0;
          }
          tbody tr:nth-child(even) {
            background-color: #f9f9f9;
          }
        </style>
      </head>
      <body>
        <table>
          <thead>
            <tr>${tableHeaders}</tr>
          </thead>
          <tbody>
            ${tableRows}
          </tbody>
        </table>
      </body>
      </html>
    `
    .trim()
    .toString();
};
